import React, { useEffect, useState, useRef } from 'react'
import { observer } from 'mobx-react';
import { useStore } from '../../../stores';
import PreviewBrief from '../BriefPreview';
import {PaginationControls, SearchBar} from '../../../components';
import {AvailableBriefsTable} from './auditComponents';
import { useServerFilter } from "../../../hooks/useServerFilter";
import { formatDate, processQuote, financialCalculations, formatCash, handlePagination } from '../../../utils/sharedFunctions';
import './style.scss';

const Credipple = `${process.env.REACT_APP_CDN_URL}/globalAssets/CredippleLogo.svg`;
const MoveFoward = `${process.env.REACT_APP_CDN_URL}/globalAssets/Audit/MoveFoward.svg`;
const MoveBackward = `${process.env.REACT_APP_CDN_URL}/globalAssets/Audit/MoveBackward.svg`;
const SearchIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/SearchIcon.svg`
var mobile = require('is-mobile');

const Audit = observer(() => {
    const { projectStore, uiStore } = useStore();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [YearsContainer, setYearsContainer] = useState([]);
    const [startIndex, setStartIndex] = useState(0);
    const [Briefs, setBriefs] = useState([]);
    const [YearSelected, setYearSelected] = useState('2019/2020');
    const [AvailBriefs, setAvailBriefs] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [OfferingFilter, setOfferingFilter] = useState('A-Z');
    const [ServiceCategoryFilter, setServiceCategoryFilter] = useState('A-Z');
    const [ContractTypeFilter, setContractTypeFilter] = useState('A-Z');
    const [JobStatusFilter, setJobStatusFilter] = useState('A-Z');
    const [FulfillmentLeadFilter, setFulfillmentLeadFilter] = useState('A-Z');
    const [MonthFilter, setMonthFilter] = useState('A-Z');
    const [ViewBrief, setViewBrief] = useState(false)
    const [SelectedProject, setSelectedProject] = useState({});
    const [IsFilterOn, setIsFilterOn]=useState(false);
    const [Leads, setLeads] = useState([]);
    const [Professionals, setProfessionals] = useState([]);
    const [BriefPayment2Open, setBriefPayment2Open] = useState(-1);
    const CurrentYearsArray = YearsContainer.slice(startIndex, startIndex + 5);
    const [Pagination, setPagination] = useState({ 
        currentPage :  1, 
        hasMore     : false, 
        nextCursor  : "", 
        prevCursor  : "",
        pageSize    : 8, 
        totalPages  : 0, 
        totalUsers  : 0
    })
    const isFirstRender = useRef(true);
    const { serverFilterProject } = useServerFilter({ projectStore, uiStore, setAvailBriefs, setPagination, setYearSelected, searchTerm });
    
    useEffect(() => {
        getBriefs("", "");
    }, []);
    useEffect(()=>{
        for(let i =0; i<CurrentYearsArray.length; i++){
            const x = filter2(CurrentYearsArray[i], Briefs)
            if(x.AvailBriefs.length > 0){
                setAvailBriefs(x.AvailBriefs)
                setYearSelected(x.YearSelected)
                break;
            }
        }
    },[Briefs]);
    useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false; 
            return; 
        }else{
            if (searchTerm !== "") {
                serverFilterProject(YearSelected, searchTerm, "", "");
            }else{
                getBriefs("", "");
                setIsFilterOn(false);
            };
        };
    }, [searchTerm]);
    useEffect(()=>{
        const [year1, year2] = YearSelected.split("/");
        const currYear = new Date().getFullYear();
        if(Number(year1) !== currYear || Number(year2) !== currYear){
            setIsFilterOn(true);
        }else{
            setIsFilterOn(false);
        }
    },[YearSelected]);
    
    const filter2 = (e, Briefs) => {
        let selectedYear = e;
        const [year1, year2] = selectedYear.split("/");
        var filteredBriefs = [];
        if (Briefs === 'error') {
            return {"AvailBriefs": [], "YearSelected": selectedYear}
        } else {
            filteredBriefs = Briefs.filter((item) => {
                let newDate = new Date(item.createdAt);
                
                if (!isNaN(newDate.getTime())) {
                    const itemYear = newDate.getFullYear().toString();
                    return itemYear === year1 || itemYear === year2;
                };
            });
        };
        const AvailBriefs = filteredBriefs.filter(brief => {
            const searchValue = searchTerm.toLowerCase();
            // Check both standard fields AND our new migrated fields
            const titleMatch = (brief?.title || brief?.briefTitle || "").toLowerCase().includes(searchValue);
            const clientMatch = (
                brief?.client?.lastName?.toLowerCase().includes(searchValue) || 
                brief?.client?.email?.toLowerCase().includes(searchValue) ||
                (brief?.isMigrated && brief?.staticValues?.clientName?.toLowerCase().includes(searchValue))
            );
            
            return titleMatch || clientMatch;
        });
        return {"AvailBriefs":AvailBriefs, "YearSelected":selectedYear}
    };
    const getBriefs = async (lastId, navId) => {
        uiStore.setLoading(true);
        try {
            const years = getYears("");
            const projects = await projectStore.getProjects(lastId, navId);
            
            setYearsContainer(years);
            setAvailBriefs(Array.isArray(projects?.projects) ? projects.projects : []);
            setBriefs(Array.isArray(projects?.projects) ? projects.projects : []);
            setPagination({
                currentPage :  projects?.currentPage ?? 1,
                hasMore     :  projects?.hasMore ?? false,
                nextCursor  :  projects?.nextCursor ?? "",
                prevCursor  :  projects?.prevCursor ?? "",
                pageSize    :  projects?.pageSize ?? 8,
                totalPages  :  projects?.totalPages ?? 0,
                totalItems  :  projects?.totalBriefs ?? 0
            });
            forceUpdate();
        } catch (e) {;
            uiStore.showNotification("Failed to fetch projects. Please try again later.","error");
        } finally {
            uiStore.setLoading(false);
        }   
    };
    const handlePageChange = (e) => {
        handlePagination({
            action: e,
            pagination: Pagination,
            isFilterOn: IsFilterOn,
            yearSelected: YearSelected,
            searchTerm: searchTerm,
            serverFilterProject: serverFilterProject,
            getBriefs: getBriefs
        });
    };
    function  getYears (currYear) {
        let  currValue = "";
        if (currYear === "") {
            currValue = "2019/2020";
                }else{
            currValue = currYear;
        };

        const [startYear, endYear] = currValue.split('/').map(Number);
        const yearsArray = [];

        for (let i = 0; i < 15; i++) {
            yearsArray.push(`${startYear + i}/${endYear + i}`);
        };

        return yearsArray; 
    };
    const handleForward = () => {
        let yearsContainer =[...YearsContainer];
        const year1 = Number(yearsContainer[1].split('/')[0]);
        const year2 = Number(yearsContainer[1].split('/')[1]);
        const filterYear = `${year1 + 4}/${year2 + 4}`;
        const years= getYears(filterYear);

        if (startIndex + 5 < YearsContainer.length) {
            setStartIndex(startIndex + 1);
        };
        setYearsContainer(years);
    };
    const handleBackward = () => {
        let yearsContainer =[...YearsContainer];
        const year1 = Number(yearsContainer[1].split('/')[0]);
        const year2 = Number(yearsContainer[1].split('/')[1]);
        const filterYear = `${year1 - 4}/${year2 - 4}`;

        const years= getYears(filterYear);

        if (startIndex > 0) {
            setStartIndex(startIndex - 1);
        };
        setYearsContainer(years);
    };
    const handleTitleFilterComps = (e) => {
        let sortedBriefs = [...Briefs];
        const id = e.target.id.toLowerCase();

        const sortBriefs = (property, stateUpdater, isNested = false) => {
            stateUpdater(prev => {
                const isAscending = prev === 'A-Z';
                sortedBriefs.sort((a, b) => {
                    // Handle nested object properties
                    const valA = isNested ? a[property]?.fullName : a[property];
                    const valB = isNested ? b[property]?.fullName : b[property];

                    // Handle null/undefined values
                    if (!valA && !valB) return 0;
                    if (!valA) return 1;
                    if (!valB) return -1;

                    return isAscending
                        ? valB.toString().localeCompare(valA.toString())
                        : valA.toString().localeCompare(valB.toString());
                });

                setBriefs(sortedBriefs);
                const filtered = sortedBriefs.filter(brief => {
                    const searchValue = searchTerm.toLowerCase();
                    return (
                        brief?.title?.toLowerCase().includes(searchValue) ||
                        brief?.client?.lastName?.toLowerCase().includes(searchValue) ||
                        brief?.client?.email?.toLowerCase().includes(searchValue)
                    );
                });
                setAvailBriefs(filtered);

                return isAscending ? 'Z-A' : 'A-Z';
            });
        };

        switch (id) {
            case 'offering':
                sortBriefs('servicesOffered', setOfferingFilter);
                break;
            case 'servicecategory':
                sortBriefs('serviceCategory', setServiceCategoryFilter);
                break;
            case 'contracttype':
                sortBriefs('contractType', setContractTypeFilter);
                break;
            case 'jobstatus':
                sortBriefs('briefStatus', setJobStatusFilter);
                break;
            case 'fulfillmentlead':
            case 'fulfilmentlead':
                sortBriefs('talentPartner', setFulfillmentLeadFilter, true); // nested property
                break;
            case 'month':
                setMonthFilter(prev => {
                    const isAscending = prev === 'A-Z';
                    sortedBriefs.sort((a, b) => {
                        const dateA = new Date(a.createdAt || 0);
                        const dateB = new Date(b.createdAt || 0);
                        return isAscending ? dateB - dateA : dateA - dateB;
                    });
                    setBriefs(sortedBriefs);
                    setAvailBriefs(sortedBriefs.filter(brief => {
                        const searchValue = searchTerm.toLowerCase();
                        return (
                            brief?.title?.toLowerCase().includes(searchValue) ||
                            brief?.client?.lastName?.toLowerCase().includes(searchValue) ||
                            brief?.client?.email?.toLowerCase().includes(searchValue)
                        );
                    }));
                    return isAscending ? 'Z-A' : 'A-Z';
                });
                break;
            default:
                uiStore.showNotification(
                `Unexpected filter id: "${id}"`,
                "warning"
                );
        break;
}

    };
    const handleSearchChange = (value) => {
        setSearchTerm(value);
        setIsFilterOn(true);
    };
    function getDaysDifference(date1, date2) {
        if (!date1 || !date2) return 'N/A';
        const [day1, month1, year1] = date1.split('/').map(Number);
        const [day2, month2, year2] = date2.split('/').map(Number);
        const firstDate = new Date(year1, month1 - 1, day1);
        const secondDate = new Date(year2, month2 - 1, day2);
        const diffTime = Math.abs(secondDate - firstDate);

        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    };
    function handleGotoPreview(item) {
        setSelectedProject(item);
        setBriefPayment2Open(-1)
        setViewBrief(true);
    }
    const backClicked = (back, isEdited) => {
        if (isEdited) {
            getBriefs("" , "");
        };
        setViewBrief(back);
        forceUpdate();
    };
    function handlerPaymentEnter(e) {
        setBriefPayment2Open(e.currentTarget.id)
    }
    function handlePaymentLeave() {
        setBriefPayment2Open(-1)
    };
    
    if (mobile()) {
        return (
            <div>
            </div>
        );
    } else {
        return (
            <div className='AuditPage'>
                <div className='AuditPageHeader'>
                    <p>Audit</p>
                    <img src={Credipple} alt='Credipple Logo' />
                </div>

                {ViewBrief ? (
                    <div style={{ width: "100%", height: "88%"  }}>
                        <PreviewBrief Briefs={AvailBriefs} setBriefs={setAvailBriefs} project={SelectedProject} navigateMainToPage={(e, isEdited) => backClicked(e, isEdited)} professionals={Professionals} leads={Leads} />
                    </div>
                ) : (
                    <div className='AuditPageBody'>
                        {/* Header */}
                        <div className='headerFilterSection'>
                            <p style={{ width: '25%',  fontWeight: '700', fontSize: '24px'}}>Project List</p>
                            
                            {/* Number of projects  */}
                            <div className='numofItems' style={{ borderRadius: '8px', padding: '10px 15px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px'}}>
                                <PaginationControls
                                    styles={{width: 'fit-content'}}
                                    currentPage={Pagination.currentPage}
                                    totalPages={Pagination.totalPages}
                                    onPageChange={handlePageChange}
                                    hasMore={Pagination.hasMore}    
                                  />
                            </div>

                            
                            <div className='filterBriefsSection'>
                                <SearchBar
                                    onSearch={(e)=>handleSearchChange(e)}
                                    placeholder='Search'
                                    value={searchTerm}
                                    debounceDelay={1000}
                                    disabled={false}
                                    className=''
                                    searchIconUrl={SearchIcon}
                                    style={{ width: '100%' }}
                                />
                            </div>

                        </div>

                        {/* Body */} 
                        <AvailableBriefsTable
                            AvailBriefs={AvailBriefs} 
                            YearSelected={YearSelected} 
                            searchTerm={searchTerm} 
                            MonthFilter={MonthFilter}
                            OfferingFilter={OfferingFilter}
                            ServiceCategoryFilter={ServiceCategoryFilter}
                            FulfillmentLeadFilter={FulfillmentLeadFilter}
                            ContractTypeFilter={ContractTypeFilter}
                            JobStatusFilter={JobStatusFilter}
                            BriefPayment2Open={BriefPayment2Open}
                            handleTitleFilterComps={handleTitleFilterComps}
                            handleGotoPreview={handleGotoPreview}
                            handlerPaymentEnter={handlerPaymentEnter}
                            handlePaymentLeave={handlePaymentLeave}
                            formatCash={formatCash}
                            processQuote={processQuote}
                            financialCalculations={financialCalculations}
                            getDaysDifference={getDaysDifference}
                            formatDate={formatDate}
                        /> 

                        {/* Year selector */}
                        <div className='filterByYearSection'>
                            <div className='moveBackwardsBtn' onClick={handleBackward} disabled={startIndex === 0}>
                                <img src={MoveBackward} />
                            </div>
                            <div className='availTabsSection'>
                                {CurrentYearsArray.map((item, index) => (
                                    <div key={index} className='availDatesCard' id={item} onClick={() => serverFilterProject(item, searchTerm, "", "")} style={{ backgroundColor: YearSelected === item ? '#6D4194' : '', color: YearSelected === item ? '#fff' : '' }}>
                                        {item}
                                    </div>
                                ))}
                            </div>
                            <div className='moveForwardsBtn' onClick={handleForward} disabled={startIndex + 5 >= YearsContainer.length}>
                                <img src={MoveFoward} />
                            </div>
                        </div>

                    </div>
                )}
            </div>
        );
    }
})

export default Audit;